import React from "react";
import Header from "../components/Header";
import GeoLoc from "../components/GeoLoc";
import HowWeDo from "../components/HowWeDo";

const Home = () => {
  return (
    <div>
      <Header />
      <GeoLoc />
      <HowWeDo />
    </div>
  );
};

export default Home;
